<!--
 * @Author: van
 * @Date: 2021-09-28 16:46:23
 * @LastEditors: van
 * @LastEditTime: 2021-10-07 10:26:12
-->
<template>
  <el-dialog class="auth"
             :visible.sync="authVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             width="1000px"
             :title="$t('goodsList.auth.dialogTitle')"
             :modal-append-to-body="false"
             append-to-body>
    <div class="container"
         v-loading="loading">
      <el-form ref="authForm"
               :model="authForm"
               label-width="100px" @keydown.enter.native.prevent>
        <el-row :gutter="20">
          <template v-for="(item,index) in this.authKeyList">
            <el-col :span="24"
                    :key="index">
              <el-form-item :label="item.name"
                            :rules="[{required: true, message: `${$t('goodsList.auth.inputPlaceholder')}${item.name}`}]"
                            :prop="item.key"
                            size="small">
                <el-input clearable
                          :placeholder="`${$t('goodsList.auth.inputPlaceholder')}${item.name}`"
                          size="small"
                          v-model="authForm[item.key]">
                </el-input>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
      </el-form>
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 type="primary"
                 @click="save"
                 :loading="loading">{{$t('goodsList.auth.save')}}</el-button>
      <el-button size="small"
                 @click="authVisible = false">{{$t('goodsList.auth.close')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import * as erpApi from "@/http/erpApi.js";
export default {
    data() {
        return {
            authForm: {},
            loading: false,
        };
    },
    methods: {
        save() {
            this.$refs["authForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    let obj = {};
                    obj = JSON.parse(JSON.stringify(this.authForm));
                    erpApi
                        .shopAuth(
                            {
                                auth_json: obj,
                                id: this.shopId,
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "授权成功"
                                        : "Success"
                                );
                                this.closeDialog();
                                this.$parent.$parent.closeDialog();
                                this.loading = false;
                            } else {
                                this.loading = false;
                            }
                        });
                }
            });
        },
        /**
         * 窗口关闭
         */
        closeDialog() {
            this.authForm = {};
            this.$refs["authForm"].clearValidate();
            // this.$refs["authForm"].resetFields();
            this.$emit("update:authKeyList", []);
            this.$emit("update:authVisible", false);
        },
    },
    computed: {
        mixed() {
            const { authVisible, authKeyList, shopId } = this;
            return {
                authVisible,
                authKeyList,
                shopId,
            };
        },
    },
    watch: {
        mixed: {
            handler(newValue) {
                if (newValue.authVisible) {
                    this.shopId = newValue.shopId;
                }
            },
            deep: true,
            immediate: false,
        },
    },
    props: {
        authVisible: Boolean,
        shopId: Number,
        authKeyList: Array,
    },
};
</script>
<style lang="scss">
.auth {
    .el-form-item__content {
        .el-select,
        .el-select--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }
}
</style>